import React from 'react';
import { useSelector } from 'react-redux';
import ZenSignFooter from './ZenSignFooter';
import ShareFooter from './ShareFooter';

function Footer() {
  const type = useSelector((state) => state.auth.user.type);

  if (type === 'folder-share') {
    return <ShareFooter />;
  }

  return <ZenSignFooter />;
}

export default Footer;
